const year = new Date().getFullYear();

export default {
	footerText: `© ${year} G7CR Technologies India Pvt. Ltd.`,
	ActivitiesMonthRangeLimit: 6
};
